import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Product } from '../models/Product';

@Injectable()
export class ProductService {
  constructor(private http: HttpClient) { }

  getProductData(): Promise<Product[]> {
    return this.http.get('product')
      .toPromise()
      .then((data: any[]) => data.map(d => new Product(d)))
      .catch(err => {
        console.error(err);
        return err;
      });
  }

  getNurseryDataId(id): Promise<any> {
    return this.http.get(`product/${id}`)
      .toPromise()
      .then(this.handleProductData)
      .catch(err => {
        console.error(err);
        return err;
      });
  }

  getProductionTypes() {
    return this.http.get('production')
      .toPromise()
      .then(this.handleProductionType)
      .catch(err => {
        console.error(err);
        return err;
      });
  }

  getPackagingTypes() {
    return this.http.get('packaging')
      .toPromise()
      .then(this.handlePackagingType)
      .catch(err => {
        console.error(err);
        return err;
      });
  }

  getProductTypes() {
    return this.http.get('product_type')
      .toPromise()
      .then(this.handleProductType)
      .catch(err => {
        console.error(err);
        return err;
      });
  }

  private handleProductData(res) {
    return res || { };
  }

  private handleProductType(res) {
    return res || { };
  }

  private handleProductionType(res) {
    return res || { };
  }

  private handlePackagingType(res) {
    return res || { };
  }
}
